<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p><strong>A short guide to the mysteries of time and the nature of existence as expressed in various media.</strong></p>
<p><strong>The author records his own views on time, space with accompanying food, art and music recommendations in a tongue in cheek fashion.</strong></p>
<p><strong>Some aspects of Einstein’s theories and later developments in astrophysics are covered with minimal use of mathematics.</strong></p>
<p><strong>The author has created illustrations to augment the text.</strong></p>
<br/><p style="text-align: center;"><strong>****</strong></p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1caf5038